"use client";

import Link from "next/link";
import { LoadingSpinner } from "~/components/LoadingSpinner";
import { buttonVariants } from "~/components/ui/button";
import { Paths } from "~/lib/Paths";
import { cn } from "~/lib/utils";
import { MouseEvent } from "react";
import { generatePath } from "~/lib/client/utils";
import { useTranslations } from "~/hooks/useTranslations";

type SaleOpenProps = {
  eventOrBundleId:
    | { case: "event"; value: string }
    | { case: "bundle"; value: string };
  onClick?: () => void;
  loading?: boolean;
  className?: string;
  backgroundColor?: string;
};

export function SaleOpen(props: SaleOpenProps) {
  const t = useTranslations();

  const handleClick = (e: MouseEvent) => {
    if (props.loading) {
      e.preventDefault();
      return;
    }

    if (typeof props.onClick !== "undefined") props.onClick();
  };

  return (
    <Link
      className={cn(
        buttonVariants({ variant: "default" }),
        "w-full font-bold aria-disabled:opacity-70",
        props.className,
      )}
      href={
        props.eventOrBundleId.case === "event"
          ? generatePath(Paths.TICKETS, {
              eventId: props.eventOrBundleId.value,
            })
          : generatePath(Paths.TICKETS_BUNDLE, {
              bundleId: props.eventOrBundleId.value,
            })
      }
      onClick={handleClick}
      prefetch={false}
      aria-disabled={props.loading}
      aria-busy={props.loading}
      style={{ backgroundColor: props.backgroundColor }}
    >
      {props.loading && (
        <LoadingSpinner width={8} height={8} className="mr-1" />
      )}
      {t.buy_ticket}
    </Link>
  );
}
